"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDatePickerSelect = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DatePickerSelectMixin = require("../../mixins/components/DatePickerSelectMixin");
var StyledDatePickerSelect = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledDatePickerSelect",
  componentId: "c11n-8-107-0__sc-1y0so0n-0"
})(["", ""], _DatePickerSelectMixin.DatePickerSelectMixin);
exports.StyledDatePickerSelect = StyledDatePickerSelect;